/* eslint-disable react/require-default-props */
import React from 'react';
import styled from 'styled-components';

import breakpoints from '@rsc/ui-components/breakpoints';
import sharedStyles from '@rsc/ui-components/styles';

const Container = styled.div<{
  isCompanyOwned: boolean;
  hasStorefront: boolean;
}>`
  width: 100%;

  ${({ hasStorefront, isCompanyOwned }) =>
    isCompanyOwned && !hasStorefront && 'display: none'};

  p {
    margin: ${sharedStyles.spacing['spacing-1xs']} 0;
  }

  @media (min-width: ${breakpoints.md}) {
    width: calc(
      50% - ${parseInt(sharedStyles.spacing['spacing-md'], 10) / 2}rem
    );
  }

  @media (min-width: ${breakpoints.lg}) {
    width: calc(
      40% - ${parseInt(sharedStyles.spacing['spacing-md'], 10) / 2}rem
    );
  }
`;

const AdditionalInfoContainer = styled.div`
  margin: ${sharedStyles.spacing['spacing-md']} 0 0;
`;

const getOpeningHours = day => {
  if (!day?.isOpen) {
    return 'Closed';
  }

  return `${day?.openingHours?.replace(
    /^0(?:0:0?)?/,
    ''
  )} - ${day?.closingHours?.replace(/^0(?:0:0?)?/, '')}`;
};

const findDayOfWeek = (days, day) =>
  days.find(activeDay => activeDay.dayOfWeek === day);

export type OpeningHoursProps = {
  hours: {
    dayOfWeek?: string;
    isOpen?: boolean;
    openingHours?: string;
    closingHours?: string;
  }[];
  additionalInfo?: string;
  isCompanyOwned?: boolean;
  hasStorefront?: boolean;
};

function OpeningHours({
  hours,
  additionalInfo = '',
  isCompanyOwned = false,
  hasStorefront = false,
}: Readonly<OpeningHoursProps>) {
  return (
    <Container isCompanyOwned={isCompanyOwned} hasStorefront={hasStorefront}>
      <h2>{isCompanyOwned ? 'Walk-In Store Hours' : 'Operating Hours'}</h2>

      {hours?.length > 0 && (
        <div>
          <p>Mon: {getOpeningHours(findDayOfWeek(hours, 'monday'))}</p>
          <p>Tue: {getOpeningHours(findDayOfWeek(hours, 'tuesday'))}</p>
          <p>Wed: {getOpeningHours(findDayOfWeek(hours, 'wednesday'))}</p>
          <p>Thu: {getOpeningHours(findDayOfWeek(hours, 'thursday'))}</p>
          <p>Fri: {getOpeningHours(findDayOfWeek(hours, 'friday'))}</p>
          <p>Sat: {getOpeningHours(findDayOfWeek(hours, 'saturday'))}</p>
          <p>Sun: {getOpeningHours(findDayOfWeek(hours, 'sunday'))}</p>
        </div>
      )}
      <AdditionalInfoContainer>
        {additionalInfo && <p>{additionalInfo}</p>}
      </AdditionalInfoContainer>
    </Container>
  );
}

export default OpeningHours;
